import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-[11px] tracking-[0.32em] text-secondary-500">常见问题</span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              进站前想先弄明白的事
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于首页入口、时间线分类与现场完整记录的常见疑问，都在这里集中说明。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-background-200">
              {faqItems.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className="border-b border-background-200">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-6 py-5 text-left"
                    >
                      <span className="flex items-start gap-4">
                        <span className="font-label text-xs text-primary-600">
                          0{index + 1}
                        </span>
                        <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                      </span>
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 ${
                          isOpen
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"} />
                      </span>
                    </button>
                    <div
                      className={`grid overflow-hidden transition-all duration-300 ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <p className="min-h-0 overflow-hidden pb-5 pl-8 pr-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                        {item.a}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}